export default __webpack_public_path__ + "static/media/avatar-team-mixed.35fe952d.jpg";